import { Input } from "@material-tailwind/react";
import React from "react";
import { motion } from "framer-motion";

function Plans({ token, setToken, selectedPlan, setSelectedPlan, navigate }) {
  const plans = {
    guest: {
      title: "Guest (Anonymous)",
      description:
        "Use Loghook immediately without creating an account. Your dashboard will be temporary and limited.",
      cta: "Try as Guest",
      action: () => navigate(`/${token}`),
      background: "bg-gradient-to-bl from-gray-100 to-gray-200",
    },
    personal: {
      title: "Personal Account",
      description:
        "Create an account to save dashboards across sessions and enjoy extended retention.",
      cta: "Log In",
      action: () => navigate("/login"),
      background: "bg-gradient-to-bl from-seasalt to-ghost-white",
    },
    business: {
      title: "Business Account",
      description:
        "Invite team members and unlock advanced features for collaboration and scaling.",
      cta: "Sign Up",
      action: () => navigate("/register"),
      background: "bg-gradient-to-bl from-seashell to-cool-gray",
    },
  };

  return (
    <section className="w-full px-4 py-16 flex flex-col items-center justify-center gap-10 bg-white rounded-xl">
      <div className="flex flex-col lg:flex-row items-center justify-center gap-8 w-full">
        {/* Plan Details Selector */}
        <div className="w-full lg:w-1/2 text-center">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={`min-h-[460px] rounded-xl shadow-xl p-8 flex flex-col justify-between ${plans[selectedPlan].background}`}
          >
            <div className="text-5xl text-center mb-4">
              {selectedPlan === "guest"
                ? "🚀"
                : selectedPlan === "personal"
                ? "👤"
                : "🏢"}
            </div>
            <h4 className="text-2xl font-bold mb-2 text-center">
              {plans[selectedPlan].title}
            </h4>
            <p className="text-gray-700 mb-6 text-lg text-center">
              {plans[selectedPlan].description}
            </p>

            {selectedPlan === "guest" && (
              <div className="mb-6">
                <Input
                  type="text"
                  value={token}
                  label="Your Unique Token"
                  className="bg-white"
                  onChange={(e) => setToken(e.target.value)}
                />
              </div>
            )}

            <div className="text-center flex flex-col sm:flex-row gap-4 justify-center">
              {selectedPlan === "guest" ? (
                <button
                  onClick={plans[selectedPlan].action}
                  className="bg-indigo-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-800 transition duration-300"
                >
                  {plans[selectedPlan].cta}
                </button>
              ) : (
                <>
                  <button
                    onClick={() => navigate("/login")}
                    className="bg-indigo-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-800 transition duration-300"
                  >
                    Log&nbsp;In
                  </button>
                  <button
                    onClick={() => navigate("/register")}
                    className="bg-white text-indigo-600 border border-indigo-600 px-8 py-3 rounded-lg font-semibold hover:bg-indigo-50 transition duration-300"
                  >
                    Register
                  </button>
                </>
              )}
            </div>
          </motion.div>
        </div>

        {/* Comparison Table */}
        <div className="w-full lg:w-1/2 max-w-lg flex flex-col justify-center">
          <h3 className="text-xl font-semibold mb-4 text-center">
            What’s included?
          </h3>
          <div className="space-y-2">
            {[
              { label: "No login required", plans: ["guest"] },
              {
                label: "Dashboard retention",
                plans: ["personal", "business"],
              },
              {
                label: "Trigger + Action automation",
                plans: ["personal", "business"],
              },
              {
                label: "Multi-device sync",
                plans: ["guest", "personal", "business"],
              },
              { label: "Team collaboration", plans: ["business"] },
            ].map((item, index) => (
              <div
                key={index}
                className="flex justify-between items-center border-b pb-2"
              >
                <span className="text-gray-700">{item.label}</span>
                <span className="text-indigo-600 font-bold">
                  {item.plans.includes(selectedPlan) ? "✓" : "—"}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Plan selector buttons */}
      <div className="flex justify-center items-center gap-4 flex-wrap w-full">
        {Object.keys(plans).map((key) => (
          <button
            key={key}
            onClick={() => setSelectedPlan(key)}
            className={`px-5 py-2 rounded-full font-medium transition border ${
              selectedPlan === key
                ? "bg-indigo-500 text-white"
                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
            }`}
          >
            {plans[key].title}
          </button>
        ))}
      </div>
    </section>
  );
}

export default Plans;
